window.initComplementarySlider = function() {
  const sliders = document.querySelectorAll(".complementary-products--inner");
  if (!sliders.length) return;

  sliders.forEach((slider) => {

    const wrapper = slider.closest(".complementary-products");
    if (!wrapper) return;

    let next = wrapper.querySelector(".next-arrow");
    let prev = wrapper.querySelector(".prev-arrow");

    // ---- FIXED: Correct remove-listener method ----
    if (next) {
      const newNext = next.cloneNode(true);
      next.parentNode.replaceChild(newNext, next);
      next = newNext;
    }

    if (prev) {
      const newPrev = prev.cloneNode(true);
      prev.parentNode.replaceChild(newPrev, prev);
      prev = newPrev;
    }
    // ----------------------------------------------

    // Detect card width
    let card =
      slider.querySelector(".product-card-small") ||
      slider.querySelector(".card-wrapper") ||
      slider.children[0];

    if (!card) return;

    let cardWidth = card.getBoundingClientRect().width;
    let gap = parseInt(getComputedStyle(slider).columnGap) || 16;
    let scrollAmount = cardWidth + gap;

    // Add listeners
    next?.addEventListener("click", () => {
      // alert("next clicked!");
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    prev?.addEventListener("click", () => {
      // alert("prev clicked!");
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
  });
}
